import { TranslateService } from '@ngx-translate/core';

import { FileUploadOptionsModel } from '../../models/interfaces/file-upload.model';

export class FileUploadDomHelper {
    constructor(private translate: TranslateService) { }

    createTargetElement(selector: string): void {
        const elementId = selector.replace('#', '');
        if (!document.getElementById(elementId)) {
            const element = document.createElement('div');
            element.id = elementId;
            element.setAttribute('programmatically-controlled', 'true'); // Setter
            document.body.appendChild(element);
        }
    }

    cleanupTargetElement(selector: string): void {
        if (!selector) {
            return;
        }

        const elementId = selector.replace('#', '');
        const element = document.getElementById(elementId);
        if (element && element.getAttribute('programmatically-controlled')) {
            element.remove();
        }
    }

    injectCustomElements(options: FileUploadOptionsModel): void {
        this.injectModalTitle(options);
        this.injectExtensionNotice(options);
    }

    assignAttributes(options: FileUploadOptionsModel): void {
        if (!options?.overrides || !options?.dashboard?.target) {
            return;
        }

        const modalElement = document.querySelector(options.dashboard.target);
        options.overrides.forEach((item) => {
            const elements = modalElement?.querySelectorAll(item.selector);
            elements?.forEach((element: any) => {
                if (!element) {
                    return;
                }

                if (!element.hasAttribute(item.type) || element.getAttribute(item.type) !== item.override) {
                    element.setAttribute(item.type, item.override);
                }
            });
        });
    }

    private injectModalTitle(options: FileUploadOptionsModel): void {
        const modalElement = document.querySelector(options.dashboard.target);
        const dashboardWrapper = modalElement?.querySelector('.uppy-Dashboard-innerWrap');
        if (dashboardWrapper && !modalElement?.querySelector('.uppy-upload-title')) {
            dashboardWrapper.insertBefore(this.createModalTitle(), dashboardWrapper.firstChild);
        }
    }

    private injectExtensionNotice(options: FileUploadOptionsModel): void {
        const modalElement = document.querySelector(options.dashboard.target);
        const addFiles = modalElement?.querySelector('.uppy-Dashboard-innerWrap > .uppy-Dashboard-AddFiles');
        if (addFiles && !modalElement?.querySelector('.uppy-upload-extensions')) {
            addFiles.insertBefore(this.createExtensionNotice(options.general?.restrictions?.allowedFileTypes), addFiles.lastChild);
        }
    }

    private createModalTitle(): HTMLElement {
        const element = document.createElement('div');
        element.className = 'uppy-upload-title';

        const translatedTitle = this.translate.instant('UploadDocument');
        const title = translatedTitle === 'UploadDocument' ? 'Upload Document' : translatedTitle;

        element.innerHTML = `<h2>${title}</h2>`;
        return element;
    }

    private createExtensionNotice(allowedFileTypes?: string): HTMLElement {
        const element = document.createElement('div');
        element.className = 'uppy-upload-extensions';

        if (!allowedFileTypes) {
            element.innerHTML = '';
            return element;
        }

        const supportedFormatsText = this.getTranslation('SupportedFormats', 'Supported formats ');
        const filesText = this.getTranslation('Files', 'files').toLowerCase();

        element.innerHTML = `
            <div class="uppy-supported-formats">
                ${supportedFormatsText}: <span>(${allowedFileTypes} ${filesText})</span>
            </div>
        `;

        return element;
    }

    private getTranslation(key: string, fallback: string): string {
        const translation = this.translate.instant(key);
        return translation === key ? fallback : translation;
    }
}
